<template>
  <div v-show="currentStepComponent === 'first'">
    <first @change-step="changeStep" @on-login="onLogin"/> 
  </div>
  <div v-show="currentStepComponent === 'new_connection'">
    <CreateNewConnection @change-step="changeStep"/>
  </div>
  <div v-show="currentStepComponent === 'existing_connection'">
    <CreateWithExistingConnection @change-step="changeStep"/>
  </div>
  <div v-show="currentStepComponent === 'skip_login'">
    <CreateWithSkipLogin @change-step="changeStep" :authResponse="authResponse"/>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
const selectedStep = ref('first')
const authResponse = ref(null)
import first from './WhatsappSdkModeSteps/first.vue';
import CreateNewConnection from './WhatsappSdkModeSteps/CreateNewConnection.vue';
import CreateWithExistingConnection from './WhatsappSdkModeSteps/CreateWithExistingConnection.vue';
import CreateWithSkipLogin from './WhatsappSdkModeSteps/CreateWithSkipLogin.vue';

const changeStep = (step) => {
  selectedStep.value = step;
}

const onLogin = (data) => {
  console.log('onLogin', data);
  authResponse.value = data;
}

const currentStepComponent = computed(() => {
  return selectedStep.value
})
</script>